import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";

export const FormInput = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    visited,
    label,
    id,
    valid,
    disabled,
    showValidationMessage,
    touched,
    onBlurOverride,
    onChangeOverride,
    onChange,
    onBlur,
    ...others
  } = fieldRenderProps;

  const showError: string | false | null =
    showValidationMessage !== false && touched && validationMessage;

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    onBlurOverride?.(e);
    onBlur();
  };

  const handleChange = (e: InputChangeEvent) => {
    onChangeOverride?.(e);
    onChange(e);
  };

  return (
    <FieldWrapper>
      <Input
        id={id}
        label={label}
        valid={valid}
        disabled={disabled}
        onBlur={handleBlur}
        onChange={handleChange}
        {...others}
        size={others.size ?? "medium"}
        rounded={others.rounded ?? "medium"}
        fillMode={others.fillMode ?? "solid"}
      />

      {showError && <Error>{validationMessage}</Error>}
    </FieldWrapper>
  );
};
